// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { signInCreateNewAccountStyles } from "@insite/content-library/Widgets/SignIn/SignInCreateNewAccount";
import { MediaQuery } from "@rugby/XDL/Utilities";
import { css } from "styled-components";

signInCreateNewAccountStyles.signInCreateNewAccountGridContainer = {
    css: css`
        padding: 0 80px;
        align-items: flex-start;

        ${MediaQuery.lte("md")} {
            padding: 0;

            > div[class^="GridOffset"] {
                margin: 0;
            }
        }
    `,
};

signInCreateNewAccountStyles.checkoutAsGuestButton = {
    variant: "primary",
    css: css`
        margin-right: 15px;

        ${MediaQuery.between(768, 1000)} {
            margin-bottom: 15px;
            margin-right: 0;
            width: 100%;
            max-width: 218px;
        }

        ${MediaQuery.lte(570)} {
            margin-bottom: 15px;
            margin-right: 0;
            width: 100%;
            margin-bottom: 15px;
        }
    `,
};

signInCreateNewAccountStyles.createNewAccountButton = {
    variant: "secondary",
    css: css`
        ${MediaQuery.between(768, 1000)} {
            width: 100%;
            margin-bottom: 15px;
            max-width: 218px;
        }
        ${MediaQuery.lte(570)} {
            width: 100%;
            margin-bottom: 15px;
        }
    `,
};

signInCreateNewAccountStyles.signInCreateNewAccountTitleGridItem = {
    ...signInCreateNewAccountStyles.signInCreateNewAccountTitleGridItem,
    css: css`
        justify-content: left;
        padding: 0;
    `,
};

signInCreateNewAccountStyles.signInCreateNewAccountTitle = {
    ...signInCreateNewAccountStyles.signInCreateNewAccountTitle,
    css: css`
        margin-bottom: 15px;
    `,
};

signInCreateNewAccountStyles.signInCreateNewAccountTextGridItem = {
    ...signInCreateNewAccountStyles.signInCreateNewAccountTextGridItem,
    css: css`
        justify-content: left;
        text-align: left;
        padding: 0 0 20px 0;
    `,
};

signInCreateNewAccountStyles.signInCreateNewAccountButtonGridItem = {
    ...signInCreateNewAccountStyles.signInCreateNewAccountButtonGridItem,
    css: css`
        align-items: left;
        justify-content: flex-start;
        padding: 0;

        flex-direction: row;
        ${MediaQuery.between(768, 1000)} {
            flex-direction: column;
        }
        ${MediaQuery.lte(570)} {
            flex-direction: column;
        }
    `,
};
